import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import userPlaceholder from "../../assets/images/placeholder.jpg";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import Loader from "../../components/shared/Loader";
import { updateMeta } from "../../store/actions/metaAction";

const EmployeesCreate = () => {
	const auth = useSelector(state => state.auth.user);
	const history = useHistory();
	const [mainTitle, setMainTitle] = useState("");
	const [mainDescription, setMainDescription] = useState("");
	const [title, setTitle] = useState("");
	const [name, setName] = useState("");
	const [picture, setPicture] = useState(userPlaceholder);
	const [loading, setLoading] = useState(false);
	const dispatch = useDispatch();

	useEffect(() => {
		onStart();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const onStart = () => {
		dispatch(
			updateMeta({
				title: "اضافة موظف جديد",
				breadcrumb: "الموظفين",
				button: {
					show: false,
					text: null,
					link: null,
				},
			})
		);
	};

	const handlePicture = () => {
		const fileInput = document.querySelector("#picture");
		setPicture(URL.createObjectURL(fileInput.files[0]));
	};

	const handleSubmit = e => {
		e.preventDefault();
		const picture = document.querySelector("#picture");
		if (picture.files[0]) {
			setLoading(true);
			const data = new FormData();
			data.append("file", picture.files[0]);
			axios
				.post(`${process.env.REACT_APP_API_URL}/upload`, data, {
					headers: {
						Authorization: `Bearer ${cookie.get("token")}`,
						Accept: "application/json",
						"Content-Type": "multipart/form-data",
					},
				})
				.then(response => {
					const data = {
						title: mainTitle,
						description: mainDescription,
						employees: [{ name, title, image: response.data.data.name }],
					};
					axios
						.post(
							`${process.env.REACT_APP_API_URL}/posts`,
							{
								admin_id: auth.data.id,
								category_id: 6,
								data: data,
							},
							{
								headers: {
									Authorization: `Bearer ${cookie.get("token")}`,
									Accept: "application/json",
								},
							}
						)
						.then(function (response) {
							history.push("/employees/index");
							toast.success("تم اضافة الموظف بنجاح!");
							setLoading(false);
						})
						.catch(function (error) {
							toast.error("خطأ، برجاء المحاولة مره اخرى!");
							setLoading(false);
						});
				})
				.catch(error => {
					toast.error("خطأ في رفع الصورة، برجاء المحاولة مرة أخرى!");
					setLoading(false);
				});
		} else {
			toast.error("برجاء اختيار الصورة أولا!");
		}
	};

	return (
		<section>
			{loading && <Loader />}
			<form onSubmit={handleSubmit}>
				<div className="row">
					<div className="col-md-9">
						<div className="card">
							<div className="card-body">
								<div className="form-item">
									<label htmlFor="name">العنوان</label>
									<input
										type="text"
										id="name"
										required
										onChange={e => setMainTitle(e.target.value)}
									/>
								</div>
								<div className="form-item">
									<label htmlFor="name">الوصف</label>
									<input
										type="text"
										id="name"
										required
										onChange={e => setMainDescription(e.target.value)}
									/>
								</div>
								<div className="form-item">
									<label htmlFor="name">الاسم</label>
									<input
										type="text"
										id="name"
										required
										onChange={e => setName(e.target.value)}
									/>
								</div>
								<div className="form-item">
									<label htmlFor="title">الوظيفة</label>
									<input
										type="text"
										id="title"
										required
										onChange={e => setTitle(e.target.value)}
									/>
								</div>
							</div>
						</div>
					</div>
					<div className="col-md-3">
						<div className="card">
							<div className="card-body">
								<div className="form-item">
									<input type="file" onChange={handlePicture} id="picture" />
									<img src={picture} alt="avatar" className="imagePreview" />
								</div>
							</div>
						</div>
						<div className="form-item mt-3">
							<button className="bt bt-success btn-block">ارسال</button>
						</div>
					</div>
				</div>
			</form>
		</section>
	);
};

export default EmployeesCreate;
